import { PostActivity } from './activityTrack.types';

export const postActivity = ({ activityTrackClient, body }: PostActivity) =>
  activityTrackClient.post('activity-track', body);
